
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';
class KacakBasvuruAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "KacakBasvuruSave";
    super(baseUrl);
  }


  saveKacakBasvuruBasvuruSave(request: KacakBasvuruSaveRequest){
    
    return this.post("", request, false);
   
  }

}
export default new KacakBasvuruAPI();

class KacakBasvuruSaveRequest {
    basvuruTuruId: number;
    bolgeKodu: number;
    mahalleKodu: number;
    caddeSokakKodu: number;
    disKapiNo: string;
    icKapiNo?: string | null;
    kullaniciKodu?: string | null;
    tcKimlikNo?: string | null;
    cepTelefonNo?: string | null;
    aciklama: string;

    constructor(
        basvuruTuruId: number,
        bolgeKodu: number,
        mahalleKodu: number,
        caddeSokakKodu: number,
        disKapiNo: string,
        aciklama: string,
        icKapiNo?: string | null,
        kullaniciKodu?: string | null,
        tcKimlikNo?: string | null,
        cepTelefonNo?: string | null
    ) {
        this.basvuruTuruId = basvuruTuruId;
        this.bolgeKodu = bolgeKodu;
        this.mahalleKodu = mahalleKodu;
        this.caddeSokakKodu = caddeSokakKodu;
        this.disKapiNo = disKapiNo;
        this.aciklama = aciklama;
        this.icKapiNo = icKapiNo || null;
        this.kullaniciKodu = kullaniciKodu || null;
        this.tcKimlikNo = tcKimlikNo || null;
        this.cepTelefonNo = cepTelefonNo || null;
    }
}
export { KacakBasvuruSaveRequest };
